import pagination from "./Pagination.vue";
import paginationSmall from "./PaginationSmall.vue";

export const Pagination = pagination;
export const PaginationSmall = paginationSmall;